export default function AboutTeaser() {
  return (
    <section id="about" className="py-20 bg-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 border-8 border-yellow-400 rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 border-8 border-red-500 rounded-full"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <h2 className="font-barlow-condensed text-5xl md:text-7xl text-white text-center mb-12 group cursor-pointer inline-block w-full">
          <span className="group-hover:glitch transition-all">
            Who is yOKzONa?
          </span>
        </h2>

        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-12">
          <div className="flex-shrink-0">
            <div className="w-64 h-64 rounded-full border-4 border-yellow-400 p-2 animate-pulse">
              <img
                src="/WAITING FOR PLAYERS1 copy.png"
                alt="yOKzONa headshot"
                className="w-full h-full rounded-full object-cover"
                width="256"
                height="256"
                loading="lazy"
                decoding="async"
                fetchpriority="low"
              />
            </div>
          </div>

          <div className="space-y-6">
            <p className="text-gray-300 text-lg leading-relaxed">
              I've been an entrepreneur my whole life, primarily in the IT field. Recently, I stopped to pursue my true passion: <span className="text-yellow-400 font-bold">making games</span>.
            </p>

            <p className="text-gray-300 text-lg leading-relaxed">
              There's massive crossover between game dev and being an entrepreneur, and I'm taking my <span className="text-red-500 font-bold">20+ years of knowledge</span> to go full force in creating games and helping other devs achieve their dreams too.
            </p>

            <p className="text-gray-300 text-lg leading-relaxed">
              Through <span className="text-purple-400 font-bold">Waiting For Players</span>, I share insights on making games go viral, entrepreneurial strategies, and the reality of indie game development.
            </p>

            <button className="bg-[#ffed00] text-black px-8 py-4 font-bold text-lg hover-scale hover:bg-[#ffed00]/90 transition-colors mt-6">
              Full About Me
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
